import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { DealersCommisionsComponent } from './../../shared/components/dealers-commisions/dealers-commisions.component'
import { DealerCitiesComponent } from 'app/shared/components/dealer-cities/dealer-cities.component';
import { ConfigureCurrencyDealerModalComponent } from 'app/shared/components/configure-currency-dealer-modal/configure-currency-dealer-modal.component';
import { DealerModel, DealersModelExport, DealerService, DeleteDealerRQ } from 'app/open-api';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-dealers',
  templateUrl: './dealers.component.html',
  styleUrls: ['./dealers.component.scss'],
  providers: [DatePipe],
})
export class DealersComponent implements OnInit {

  public basicSelectedOption: number = 5;
  public dealers: DealerModel[] = [];
  public allDealers: DealerModel[] = [];
  public ColumnMode = ColumnMode;

  constructor(
    private dealerService: DealerService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private datePipe: DatePipe,
  ) { }

  async ngOnInit(): Promise<void> {
    this.spinner.show();
    await this.FetchModel();
    this.spinner.hide();
  }

  async FetchModel(): Promise<void> {
    await this.dealerService.apiDealerListGet().toPromise()
      .then(response => {        
        this.dealers = response.list;
        this.allDealers = response.list;
      })
      .catch(error => { });
  }

  FilterUpdate(event) {
    if (event && event !== '') {
      this.dealers = this.allDealers.filter(x => x.userName.toLowerCase().indexOf(event.toLowerCase()) > -1);
    } else {
      this.dealers = this.allDealers;
    }
  }

  DeleteDealer(dealerId: number) {
    const swal = Swal.fire({
      title: '¿Está seguro que desea eliminar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'btn btn-danger',
        cancelButton: 'btn btn-primary'
      }
    }).then(result => {
      if (result.isConfirmed) {
        this.spinner.show();
        const param: DeleteDealerRQ = {
          id: dealerId
        };
        this.dealerService.apiDealerDeletePost(param).subscribe(async response => {
          await this.FetchModel();
          this.spinner.hide();
        }, error => {
          this.spinner.hide();
        });
      }
    });
  }

  exportexcel(): void {
      /* pass here the data source */
      let exportobj: any = this.exportList();      
  
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportobj);
  
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      let newDate: Date = new Date();
      const fecha = this.datePipe.transform(newDate, "MMM/dd/yyyy");
  
      let fileName: any = `municipios_repartidores_${fecha}.xlsx`;
  
      /* save to file */
      XLSX.writeFile(wb, fileName);
    }

    exportList(): DealersModelExport[] {
        let exportflights: DealersModelExport[] = [];
        if (this.dealers){          
          this.dealers.forEach((row) => {
            const groupedCities = this.groupBy(row.cities, "stateName");
            Object.keys(groupedCities).map((e, index, values ) => {              
              let now: DealersModelExport = {
                Repartidor: row.userName,
                Provincia: e,
                Ciudades_Asignadas: groupedCities[e].map(p => p.name).join(', ')
              };
              exportflights.push(now);
            })
            
          });
        }
          
        return exportflights;
      }

      groupBy(data: any[], key: string) {        
        return data.reduce((result, currentValue) => {
          (result[currentValue[key]] = result[currentValue[key]] || []).push(
            currentValue
          );
          return result;
        }, {});
      }     

  CurrencySetting(dealerId: number) {
    const modalRef = this.modalService.open(DealersCommisionsComponent, {
      windowClass: 'myCustomModalClass'
    });
    modalRef.componentInstance.dealerId = dealerId;
    const dealer = this.GetDealerById(dealerId);
    if(dealer){
      modalRef.componentInstance.dealerName = dealer.userName;
     // modalRef.componentInstance.dealerCities = dealer.cities;
    }
  }

  GetDealerById(id: number){
    return this.dealers.find(dealer => dealer.id === id);
  }

  CityAssigment(dealerId: number) {
    const modalRef = this.modalService.open(DealerCitiesComponent, {
      windowClass: 'modal',
      size: 'lg'
    });
    const dealer = this.GetDealerById(dealerId);
    if(dealer){
      modalRef.componentInstance.dealerName = dealer.userName;
     // modalRef.componentInstance.dealerCities = dealer.cities;
    }
      
    modalRef.componentInstance.dealerId = dealerId;

    /*modalRef.result.then(async result => {
      this.spinner.show();
      await this.FetchModel();
      this.spinner.hide();
     });*/
  }
}
